module.exports = QuickAddWrapper;